const initialState = {
  visible:false,
	photoList: [],
	photoIndex: 0,
};

export default function reducer(state = initialState, action) {

	if (action.type === 'LIGHTBOX_OPEN') {
		let newState = Object.assign({}, state);
    newState.visible = true;
		newState.photoList = action.payload.photoList;
    newState.photoIndex = action.payload.photoIndex;
		return newState;
	}
  else if (action.type === 'LIGHTBOX_CLOSE') {
		let newState = Object.assign({}, state);
    newState.visible = false;
		newState.photoList = [];
    newState.photoIndex = 0;
		return newState;
	}
  else if (action.type === 'LIGHTBOX_NEXT') {
    let photoIndex = state.photoIndex + 1;
    let newState = Object.assign({}, state);
		newState.photoIndex = photoIndex;
		return newState;
	}
  else if (action.type === 'LIGHTBOX_PREV') {
    let photoIndex = state.photoIndex - 1;
    let newState = Object.assign({}, state);
		newState.photoIndex = photoIndex;
		return newState;
	}
	else {
		return state;
	}
}
